import { Banner, BannerDescription } from 'app/KinerjaShared/components/Banner'
import useToggleSdk from 'utils/useToogleSdk'

export function BannerPengembangan() {
  const toggles = useToggleSdk()

  const isBannerPengembanganEnabled =
    toggles?.['kinerja-harian-banner-pengembangan-enabled'] === true

  if (!isBannerPengembanganEnabled) {
    return null
  }

  return (
    <Banner variant="info">
      <BannerDescription>
        <strong>Pengembangan Bertahap</strong>: Pengiriman data belum dapat
        dilakukan. Sehingga, data belum tampil di E-Kinerja.
      </BannerDescription>
    </Banner>
  )
}
